<script>
    import {
        productos,
        actualizarPrecio,
        traerProductos,
    } from './_productos.svelte';
    import {
        comoMoneda,
        buildSearch,
        keydowns,
        clearOnEscape,
    } from '../../utils';
    import MonedaInput from '../../components/moneda-input.svelte';

    let tipo = 'existencias';
    const tipos = {
        existencias: ({ cantidad }) => cantidad > 0,
        pedido: ({ cantidad, ha_sido_comprado }) =>
            (ha_sido_comprado && cantidad === 0) || cantidad < 0,
        todo: () => true,
    };
    $: tipo, (nombre = '');

    let cantidadPedidoPorSlug = {};
    $: haciendoPedido = tipo === 'pedido';

    let nombre = '';
    $: nombreRe = buildSearch(nombre);
    $: productosFiltrados = $productos
        .filter(tipos[tipo])
        .filter(({ slug }) => slug.match(nombreRe))
        .map(prod => ({
            ...prod,
            valorInventario: prod.cantidad * prod.costo,
        }));
    $: subtotalPedido = -productosFiltrados.reduce(
        (subtotal, { cantidad, costo }) => subtotal + cantidad * costo,
        0
    );
    $: totalInventario = productosFiltrados.reduce(
        (total, { cantidad, costo }) => total + cantidad * costo,
        0
    );
</script>

<svelte:head>
    <title>Productos</title>
</svelte:head>

<div class="flex">
    <div class="m-auto">
        <table class="sticky border" class:filtrados="{nombre}" id="productos">
            <thead>
                <tr>
                    <td colspan="5">
                        <div class="group">
                            {#each Object.keys(tipos) as value}
                                <button
                                    class:active="{tipo == value}"
                                    on:click="{() => (tipo = value)}"
                                    class="capitalize"
                                >
                                    {value}
                                </button>
                            {/each}
                        </div>
                    </td>
                    {#if tipo === 'existencias'}
                        <td></td>
                    {/if}
                </tr>
                <tr>
                    <th class="text-right">Cantidad</th>
                    <th class="text-left">Nombre</th>
                    <th class="text-right">Precio</th>
                    <th class="text-right">Descuento</th>
                    <th class="text-right">Costo</th>
                    {#if tipo === 'existencias'}
                        <th class="text-right">Valor</th>
                    {/if}
                </tr>
                <tr class:hidden="{haciendoPedido}">
                    <th></th>
                    <th>
                        <input
                            use:clearOnEscape
                            bind:value="{nombre}"
                            class="w-full mb-2"
                        />
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {#if tipo === 'existencias'}
                        <th></th>
                    {/if}
                </tr>
            </thead>
            <tbody>
                {#each productosFiltrados as { ha_sido_comprado, nombre, costo, precio, descuento, slug, cantidad, valorInventario } (slug)}
                    <tr class:bg-green-100="{ha_sido_comprado}">
                        <td
                            class="text-right"
                            class:text-red-700="{cantidad < 0}"
                        >
                            {cantidad}
                        </td>
                        <td>{nombre}</td>
                        <td class="text-right">
                            {#if !haciendoPedido}
                                <MonedaInput>
                                    <input
                                        use:clearOnEscape
                                        use:keydowns
                                        on:keydown.Enter="{evt => actualizarPrecio(
                                                {
                                                    slug,
                                                    precio: evt.target.value,
                                                }
                                            )}"
                                        type="number"
                                        step=".001"
                                        value="{precio}"
                                    />
                                </MonedaInput>
                            {:else}{comoMoneda(precio)}{/if}
                        </td>
                        <td class="text-right">{descuento * 100}%</td>
                        <td class="text-right">{comoMoneda(costo)}</td>
                        {#if tipo === 'existencias'}
                            <td class="text-right">
                                {comoMoneda(valorInventario)}
                            </td>
                        {/if}
                    </tr>
                {/each}
            </tbody>
            {#if haciendoPedido}
                <tfoot>
                    <tr>
                        <td colspan="4" class="text-right">Subtotal</td>
                        <td class="text-right">{comoMoneda(subtotalPedido)}</td>
                    </tr>
                    <tr>
                        <td colspan="4" class="text-right">IVA AL 16%</td>
                        <td class="text-right">
                            {comoMoneda(subtotalPedido * 0.16)}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4" class="text-right">Total</td>
                        <td class="text-right">
                            {comoMoneda(subtotalPedido * 1.16)}
                        </td>
                    </tr>
                </tfoot>
            {/if}
            {#if tipo === 'existencias'}
                <tfoot>
                    <tr>
                        <td colspan="5" class="text-right">Total Inventario</td>
                        <td class="text-right">
                            {comoMoneda(totalInventario)}
                        </td>
                    </tr>
                </tfoot>
            {/if}
        </table>
    </div>
</div>
